import { Column } from "@faire/web/slate/Layout";
import { SpacerValueOrKey } from "@faire/web/slate/spacing/getSpacing";
import { useObservable } from "@faire/web/ui/hooks/useObservable";
import * as React from "react";

import { ILeanBrandTileRendererBaseProps } from "@faire/retailer/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";
import { LeanBrandTileRendererForCarouselBase } from "@faire/retailer/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererForCarouselBase";
import { ILeanBrandTileWithReview } from "@faire/retailer/components/LeanBrandTileRenderer/ILeanBrandTileWithReview";
import { SignUpElement } from "@faire/retailer/lib/popSignUp";

interface ILeanBrandTileRendererForCarouselProps
  extends Pick<
    ILeanBrandTileRendererBaseProps,
    "brandPageQueryParams" | "useLazyImageLoading"
  > {
  /**
   * Intentional, when undefined, we render the loading tile
   */
  leanBrandTile?: ILeanBrandTileWithReview;
  onClick?: (token: string) => void;
  bottomPadding?: SpacerValueOrKey;
  showMinimum?: boolean;
  signUpSourceId?: string;
  signUpElement?: SignUpElement; // For unique cases not being used in a carousel
}

export const LeanBrandTileRendererForCarousel: React.FC<
  ILeanBrandTileRendererForCarouselProps
> = ({
  onClick,
  leanBrandTile,
  brandPageQueryParams,
  bottomPadding,
  showMinimum,
  useLazyImageLoading,
  signUpSourceId,
  signUpElement,
}) => {
  const token = useObservable(() => leanBrandTile?.brand?.token);

  const handleClick = () => {
    if (onClick && token) {
      onClick(token);
    }
  };
  return (
    <Column
      style={{ height: "100%" }}
      data-test-id={`lean-brand-tile-renderer-onclick-container-${token}`}
      onClick={handleClick}
    >
      <LeanBrandTileRendererForCarouselBase
        brandTile={leanBrandTile}
        brandPageQueryParams={brandPageQueryParams}
        bottomPadding={bottomPadding}
        showMinimum={showMinimum}
        useLazyImageLoading={useLazyImageLoading}
        signUpTracking={{
          element: signUpElement ?? SignUpElement.CAROUSEL,
          sourceId: `${signUpSourceId}`,
        }}
      />
    </Column>
  );
};
